// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__5x2cA","primary":"loader_primary__hfAL2","secondary":"loader_secondary__jf0SD","third":"loader_third__FIzYN","critical":"loader_critical__sts3d"};